export default __webpack_public_path__ + "static/logo-gold-0f47105510c15b06fa109ee42a74b4b4.svg";